import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import green from '@mui/material/colors/green'
import grey from '@mui/material/colors/grey'

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },

  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
        margin: 'normal',
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
        variant: "contained",
        color: "primary",
      },
      variants: [
        {
          props: { variant: 'light' },
          style: {
            textTransform: "none", 
            //marginTop: "0.5em !important",
            //height: "2em",
            color: "#556cd6", 
            backgroundColor: "rgba(85, 108, 214, 0.08)", 
            border: "1pt solid #556cd6",
          },
        },
      ]
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small"
      }
    },
    MuiToggleButtonGroup: {
      defaultProps: {
        size: "small",
        color: "primary",
      },
    },

    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          margin: 0,
          fontSize: "14px",
        },
      },
    },


/*    MuiBox: {
      variants: [
        {
          props: { variant: 'fieldsetBox' },
          style: {
            display: "inline-block",
            borderRadius: "4px",
            border: "1px solid rgba(0, 0, 0, 0.23)",
          },
        },
      ]
    },
*/
  }
});

export default theme;
